'use client';

import { AccordionGroupProps, AccordionProps } from './types';
import React, { ReactElement, useEffect, useState } from 'react';

export function AccordionGroup({ children, allowMultiple = false }: AccordionGroupProps) {
	const accordions = React.Children.toArray(children);

	const [state, setState] = useState<Record<string, boolean>>(
		accordions.reduce((acc, child, index) => {
			acc[`accordion-${index}`] = false;
			return acc;
		}, {} as Record<string, boolean>)
	);

	useEffect(() => {
		if (allowMultiple) {
			return;
		}

		// close all accordions
		setState((prevState) => {
			const newState = { ...prevState };
			Object.keys(newState).forEach((key) => {
				newState[key] = false;
			});
			return newState;
		});
	}, [allowMultiple]);

	const onHeadingPress = (id: string) => {
		if (allowMultiple) {
			setState((prevState) => ({ ...prevState, [id]: !prevState[id] }));
		} else {
			setState((prevState) => {
				const newState = Object.keys(prevState).reduce((acc, key) => {
					acc[key] = false;
					return acc;
				}, {} as Record<string, boolean>);

				newState[id] = !prevState[id];

				return newState;
			});
		}
	};

	return (
		<>
			{accordions.map((accordion, i) =>
				React.cloneElement(
					accordion as ReactElement<AccordionProps>,
					{
						id: `accordion-${i}`,
						expanded:
							(accordion as ReactElement<AccordionProps>)?.props?.expanded ||
							state[`accordion-${i}`],
						onHeadingPress,
					} as AccordionProps
				)
			)}
		</>
	);
}
